"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderSetType = void 0;
var SalesOrderSetType;
(function (SalesOrderSetType) {
    SalesOrderSetType["DASH"] = "dash";
    SalesOrderSetType["CHASSIS"] = "chassis";
    SalesOrderSetType["CEIL"] = "ceil";
    SalesOrderSetType["BULK"] = "bulk";
})(SalesOrderSetType = exports.SalesOrderSetType || (exports.SalesOrderSetType = {}));
//# sourceMappingURL=sales-order-set-type.enum.js.map